<template>
    <div>
        <vue-select
            v-model="selected"
            :options="options"
            :label="textField"
            class="st-autocomplete form-control"
            :name="name"
            :class="customClass"
            :reduce="el => el[valueField]"
            :clearable="clearable"
            :disabled="disabled"
            :placeholder="placeholder"
            :filter="filterOptions"
        >
            <template #no-options="{}">
                {{ $t('GENERAL.AUTOCOMPLETE_NO_OPTIONS') }}
            </template>
        </vue-select>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        name: 'StAutocomplete',
        props: {
            value: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                default: () => [],
            },
            name: {
                type: String,
                required: true,
            },
            textField: {
                type: String,
                default: 'text',
            },
            valueField: {
                type: String,
                default: 'value',
            },
            customClass: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            reference: String,
            clearable: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: '',
            },
            fields: Object,
            model: Object,
            formValidation: Object,
        },
        data() {
            return {
                field: this.fields?.[this.name],
            }
        },
        watch: {
            options(newValue) {
                if (this.field?.autocompleteRequired) {
                    if (!this.field.enabledValidation) {
                        this.formValidation[newValue.length ? 'enableValidator' : 'disableValidator'](this.field.name);
                    }

                    this.formValidation.resetField(this.field.name, true);
                }
            },
            selected(newValue, oldValue) {
                if (newValue === oldValue) return false;
                if (newValue && this.field?.autocompleteRequired) {
                    this.formValidation.revalidateField(this.field.name, true);
                }
                this.$emit('change', newValue);
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                    this.$emit('change', val);
                }
            },
            hasParents() {
                return !!this.field?.parentFields.length;
            },
        },
        methods: {
            addWatchers() {
                const callbackFn = this.watcherCallbackFn;
                this.field.parentFields.forEach((el) => {
                    this.$watch(`model.${el.name}`, callbackFn, { deep: true });

                    this.field.fetchParams = { parent_id: this.model[el.name] };
                    this.field.updateOptions();
                }, this);

            },
            watcherCallbackFn(newValue, oldValue) {
                if (newValue === oldValue) return false;
                this.model[this.field.name] = '';
                this.field.fetchParams = { parent_id: newValue };
                this.field.updateOptions();
            },
            /**
             * Filter options from start only
             * Usign unicode normalization form of the options text
             */
            filterOptions(options, search) {
                return options.filter((el) => el[this.textField].toLowerCase().normalize('NFKD').replace(/[^\w]/g, '').startsWith(search.toLowerCase()));
            },
        },
        async mounted() {
            if (this.field) {
                await this.field.updateOptions();
            }
            if (this.hasParents) {
                this.addWatchers();
            }
        },
        beforeDestroy() {
            if (this.field && this.field.fetchParams) {
                this.field.fetchParams = {};
            }
        },
    };
</script>
